<template>
  <div>
    <v-row no-gutters>
      <v-col>
        <v-card outlined>
          <v-data-table
            height="210"
            :headers="headers"
            dense
            :items="guests"
            sort-by="calories"
            class="elevation-0"
            :footer-props="{
              itemsPerPageText: 'Itens por pagina',
              itemsPerPageOptions: [5],
              showFirstLastPage: true,
            }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Hóspedes</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                >
                </v-divider>
                <AutocompleteSearchGuest
                  v-model="guest"
                  :errors="errors"
                  :dense="true"
                  class="mt-6"
                />

                <v-btn
                  color="primary"
                  dark
                  class="mb-1 ml-4"
                  @click="sendAddGuest()"
                >
                  <v-icon small>
                    {{ icons.mdiPlus }}
                  </v-icon>
                  adicionar
                </v-btn>
                <v-btn
                  color="secondary"
                  dark
                  class="mb-1 ml-4"
                  @click="showRegiterSimple()"
                >
                  <v-icon>
                    {{ icons.mdiPlus }}
                  </v-icon>
                  hóspede
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                color="error"
                @click="removeGuest(item)"
              >
                {{ icons.mdiDeleteOutline }}
              </v-icon>
            </template>
            <template v-slot:no-data>
              <div> Adicione o primeiro hóspede</div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <DialogNewGuestVue
      v-model="dialogRegisterSimpleGuest"
      @result="resultRegisterGuest"
    />
  </div>
</template>

<script>
import {
  mdiDeleteOutline,
  mdiPlus,
} from '@mdi/js'
import {
  mapGetters,
  mapMutations,
} from 'vuex'
import AutocompleteSearchGuest from '@/components/AutocompleteSearchGuest.vue'
import RegisterSimpleGuest from './RegisterSimpleGuest.vue'
import DialogNewGuestVue from './DialogNewGuest.vue'

export default {
  components: {
    AutocompleteSearchGuest,
    RegisterSimpleGuest,
    DialogNewGuestVue,
  },
  props: {
    value: {},
    errors: {},
  },

  data: () => ({
    dialogRegisterSimpleGuest: false,
    guest: '',
    headers: [{
      text: 'NOME',
      align: 'start',
      value: 'name',
    },
    {
      text: 'TELEFONE',
      value: 'cell_phone',
    },
    {
      text: 'EMAIL',
      value: 'email',
    },
    {
      text: '',
      align: 'end',
      value: 'actions',
    },
    ],
    icons: {
      mdiDeleteOutline,
      mdiPlus,
    },

  }),
  computed: {
    // proxy direto do value: sempre reflete o que o pai definiu (mesmo quando
    // atribuído de fora depois do componente já montado, ex.: applyReserve),
    // sem depender de watcher pra sincronizar um data() local
    guests: {
      get() {
        return this.value || []
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    sendAddGuest() {
      this.guests = [...this.guests, this.guest]
      this.guest = ''
    },
    removeGuest(guest) {
      this.guests = this.guests.filter(item => item !== guest)
    },
    showRegiterSimple() {
      this.dialogRegisterSimpleGuest = true
    },
    resultRegisterGuest(guest) {
      this.guests = [...this.guests, guest]
    },

  },
}
</script>

<style scoped>
nodata {
    height: 170px;
}
</style>
